import type { PinnedConnector } from '@erikdakoda/site-template-ui/types';

/** Curated Connections pin list for Forgentic (themeConfig.pinnedConnectors). */
export const FORGENTIC_PINNED_CONNECTORS: readonly PinnedConnector[] = [
  { connectorKey: 'github', kind: 'composio', name: 'GitHub', logo: '' },
  { connectorKey: 'vercel', kind: 'composio', name: 'Vercel', logo: '' },
  { connectorKey: 'neon', kind: 'composio', name: 'Neon', logo: '' },
  { connectorKey: 'linear', kind: 'composio', name: 'Linear', logo: '' },
  { connectorKey: 'gmail', kind: 'composio', name: 'Gmail', logo: '' },
  {
    connectorKey: 'healthkit',
    kind: 'os',
    name: 'HealthKit',
    logo: 'https://res.cloudinary.com/uvilo/image/upload/t_128x128_icon/v1785878336/Platforms/apple_health_dark.png',
  },
  {
    connectorKey: 'health-connect',
    kind: 'os',
    name: 'Health Connect',
    logo: 'https://res.cloudinary.com/uvilo/image/upload/t_128x128_icon/f_auto/q_auto/Platforms/health_connect_light.png',
  },
  {
    connectorKey: 'oura',
    kind: 'cloud',
    name: 'Oura',
    logo: 'https://res.cloudinary.com/uvilo/image/upload/t_128x128_icon/v1785718775/Platforms/oura_dark.png',
  },
];
